

const S3_ORIGIN = "https://fmv-data.s3.ap-south-1.amazonaws.com";
const THUMB_PATH = "/images/thumbnails/card/";

/**
 * Returns the card-thumbnail URL for a given S3 image.
 * Thumbnails live at /images/thumbnails/card/{filename}.
 * Falls back to the original URL if it doesn't belong to this bucket.
 */
export function getS3Thumb(url) {
  if (!url || !url.includes("fmv-data.s3")) return url;
  try {
    const filename = new URL(url).pathname.split("/").pop();
    if (!filename) return url;
    const webpName = filename.replace(/\.[^.]+$/, ".webp");
    return `${S3_ORIGIN}${THUMB_PATH}${webpName}`;
  } catch {
    return url;
  }
}

export function deepClean(obj) {
  if (Array.isArray(obj)) {
    return obj
      .map(deepClean)
      .filter(
        (item) =>
          item !== undefined &&
          item !== null &&
          !(typeof item === "string" && item.trim() === "") &&
          !(Array.isArray(item) && item.length === 0) &&
          !(typeof item === "object" && Object.keys(item).length === 0)
      );
  } else if (typeof obj === "object" && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const cleaned = deepClean(value);
      if (
        cleaned !== undefined &&
        cleaned !== null &&
        !(typeof cleaned === "string" && cleaned.trim() === "") &&
        !(Array.isArray(cleaned) && cleaned.length === 0) &&
        !(typeof cleaned === "object" && Object.keys(cleaned).length === 0)
      ) {
        acc[key] = cleaned;
      }
      return acc;
    }, {});
  }
  return obj;
}



export function getURLParams(filters) {
  if (!filters || Object.keys(filters).length === 0) return "";
  const cleaned = deepClean(filters);
  console.log("CLEANED FILTERS:", cleaned);
  if (Object.keys(cleaned).length === 0) return "";
  return `filters=${JSON.stringify(cleaned)}`;
}